export default "__VITE_ASSET__9eaa2310__"